/**
 * @description: 寄存明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-jcm-report">
        <div class="jm-list">
            <el-form :inline="true" size="small" :model="jm_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="jm_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="jm_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="jm_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="jm_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getStore">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库">
                    <el-select v-model="jm_list_form.store_id" filterable clearable placeholder="请选择仓库" :disabled="jm_list_form.store_disabled">
                        <el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="jm_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="jm_list_form.goods_name" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="存酒单状态">
                    <el-select v-model="jm_list_form.deposit_status" filterable clearable placeholder="请选择存酒单状态">
                        <el-option label="作废" value="-1"></el-option>
                        <el-option label="审核中" value="1"></el-option>
                        <el-option label="无效" value="2"></el-option>
                        <el-option label="有效" value="3"></el-option>
                        <el-option label="配送中" value="4"></el-option>
                        <el-option label="过期" value="6"></el-option>
                        <el-option label="完成" value="7"></el-option>
                        <el-option label="等待接收中" value="10"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="到期时间">
                    <el-select v-model="jm_list_form.expire_days" filterable clearable placeholder="请选择到期时间">
                        <el-option label="1天内" value="1"></el-option>
                        <el-option label="2天内" value="2"></el-option>
                        <el-option label="3天内" value="3"></el-option>
                        <el-option label="4天内" value="4"></el-option>
                        <el-option label="5天内" value="5"></el-option>
                        <el-option label="6天内" value="6"></el-option>
                        <el-option label="7天内" value="7"></el-option>
                        <el-option label="8天内" value="8"></el-option>
                        <el-option label="9天内" value="9"></el-option>
                        <el-option label="10天内" value="10"></el-option>
                        <el-option label="11天内" value="11"></el-option>
                        <el-option label="12天内" value="12"></el-option>
                        <el-option label="13天内" value="13"></el-option>
                        <el-option label="14天内" value="14"></el-option>
                        <el-option label="15天内" value="15"></el-option>
                        <el-option label="16天内" value="16"></el-option>
                        <el-option label="17天内" value="17"></el-option>
                        <el-option label="18天内" value="18"></el-option>
                        <el-option label="19天内" value="19"></el-option>
                        <el-option label="20天内" value="20"></el-option>
                        <el-option label="21天内" value="21"></el-option>
                        <el-option label="22天内" value="22"></el-option>
                        <el-option label="23天内" value="23"></el-option>
                        <el-option label="24天内" value="24"></el-option>
                        <el-option label="25天内" value="25"></el-option>
                        <el-option label="26天内" value="26"></el-option>
                        <el-option label="27天内" value="27"></el-option>
                        <el-option label="28天内" value="28"></el-option>
                        <el-option label="29天内" value="29"></el-option>
                        <el-option label="30天内" value="30"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="jm_list_form.content">
                        <el-select class="el-slot-select" v-model="jm_list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="寄存单号" value="relation_id"></el-option>
                            <el-option label="包厢号" value="room_name"></el-option>
                            <el-option label="姓名" value="user_name"></el-option>
                            <el-option label="手机号" value="mobile"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="jmQuery">查询</el-button>
                    <el-button @click="jmExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="jm_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="time" width="100" label="寄存时间"></el-table-column>
                <el-table-column prop="approve_time" width="100" label="审核时间"></el-table-column>
                <el-table-column prop="end_time" width="100" label="到期时间"></el-table-column>
                <el-table-column prop="server_name" label="寄存服务员"></el-table-column>
                <el-table-column prop="relation_id" width="110" label="寄存单号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="room_name" :label="'寄存包厢'"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="user_name" label="姓名"></el-table-column>
                <el-table-column prop="deposit_status_name" label="存酒单状态"></el-table-column>
                <el-table-column prop="nickname" label="微信昵称"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="寄存数量"></el-table-column>
                <el-table-column prop="store_name" label="寄存仓库"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">寄存总量:</label>
                    <div class="list-total">{{jm_quantity_total}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{jm_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jm_list_page"
                    :total="jm_list_total"
                    @current-change="getJmList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="jm_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="jm_export_sign" v-model="jm_export_all" @change="jmExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="jm_export_ids" @change="jmExportChange">
                    <el-checkbox label="time">寄存时间</el-checkbox>
                    <el-checkbox label="approve_time">审核时间</el-checkbox>
                    <el-checkbox label="end_time">到期时间</el-checkbox>
                    <el-checkbox label="server_name">寄存服务员</el-checkbox>
                    <el-checkbox label="relation_id">寄存单号</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="room_name">寄存包厢</el-checkbox>
                    <el-checkbox label="mobile">手机号</el-checkbox>
                    <el-checkbox label="user_name">姓名</el-checkbox>
                    <el-checkbox label="deposit_status_name">存酒单状态</el-checkbox>
                    <el-checkbox label="nickname">微信昵称</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="quantity">寄存数量</el-checkbox>
                    <el-checkbox label="store_name">寄存仓库</el-checkbox>
                    <el-checkbox label="admin_name">操作人</el-checkbox>
                    <el-checkbox label="remark">备注</el-checkbox>
                    <el-checkbox label="buying_price">进货单价</el-checkbox>
                    <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="jm_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="jm_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                store_list: [],
                goods_type_list: [],
                jm_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    store_id: '',
                    store_disabled: false,
                    goods_type: '',
                    goods_name: '',
                    deposit_status: '',
                    expire_days: '',
                    content: '',
                    select: 'relation_id',
				},
				jm_list: [],
				jm_list_page: 1,
                jm_list_total: 0,
                jm_export_sign: false,
				jm_export_all: false,
                jm_export_ids: [],
                jm_export_list: ['time', 'approve_time', 'end_time', 'relation_id', 'shop_name', 'room_name', 'mobile', 'user_name', 'deposit_status_name', 'nickname', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'store_name', 'buying_price', 'buying_price_total'],
                jm_export_type: '1',
                jm_quantity_total: '',
                jm_buying_price_total: '',
            }
        },
        mounted: function() {
            this.jm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.jm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.jm_list_form.shop_id = this.shop_list[0].id;
                this.getStore(this.shop_list[0].id);
                this.getGoodsType();
                this.getJmList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.jm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.jm_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jm_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.jm_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.jm_list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.jm_list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 仓库数据
            getStore: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.jm_list_form.store_id = '';
                    _this.jm_list_form.store_disabled = true;
                } else {
                    _this.jm_list_form.store_id = '';
                    _this.jm_list_form.store_disabled = false;
                    _this.setShopDefaultTime(shop_id);
                    Vue.axios.post('PublicData/api_getStoreList', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.store_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            getJmList(page) {
				const _this = this;

                _this.loading = true;
                let relation_id = "",
                    room_name = "",
                    user_name = "",
                    mobile = "";
                if(_this.jm_list_form.select == 'relation_id') {
                    relation_id = _this.jm_list_form.content;
                } else if(_this.jm_list_form.select == 'room_name') {
                    room_name = _this.jm_list_form.content;
                } else if(_this.jm_list_form.select == 'user_name') {
                    user_name = _this.jm_list_form.content;
                } else if(_this.jm_list_form.select == 'mobile') {
                    mobile = _this.jm_list_form.content;
                }
				Vue.axios.post('FinanceReport/getDepositDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.jm_list_form.start_date,
                            "end_date": _this.jm_list_form.end_date,
                            "shop_id": _this.jm_list_form.shop_id,
                            "store_id": _this.jm_list_form.store_id,
                            "goods_type": _this.jm_list_form.goods_type,
                            "goods_name": _this.jm_list_form.goods_name,
                            "deposit_status": _this.jm_list_form.deposit_status,
                            "expire_days": _this.jm_list_form.expire_days,
                            "relation_id": relation_id,
                            "room_name": room_name,
                            "user_name": user_name,
                            "mobile": mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jm_list_total = Number(res.data.response.result.count);
							_this.jm_quantity_total = res.data.response.result.quantity_total;
							_this.jm_buying_price_total = res.data.response.result.buying_price_total;
						}
						_this.jm_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			jmQuery() {
				this.getJmList(1);
            },
            // 导出
            jmExportAll(val) {
				this.jm_export_ids = val ? this.jm_export_list : [];
				this.jm_export_sign = false;
			},
			jmExportChange(val) {
				const len = val.length;
				this.jm_export_all = len === this.jm_export_list.length;
				this.jm_export_sign = len > 0 && len < this.jm_export_list.length;
			},
            jmExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport/detailCommonExport?bill_type=deposit"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.jm_export_ids = res.data.response.result.export_fields;
                            _this.jm_export_type = res.data.response.result.export_type;
                        } else {
                            _this.jm_export_ids = _this.jm_export_list;
                            _this.jm_export_type = '1';
                        }
                        _this.jmExportChange(_this.jm_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.jm_list_export)
                }, function() {
                    _this.jmExport();
                });
            },
            jmExport: function() {
                let relation_id = "",
                    room_name = "",
                    user_name = "",
                    mobile = "";
                if(this.jm_list_form.select == 'relation_id') {
                    relation_id = this.jm_list_form.content;
                } else if(this.jm_list_form.select == 'room_name') {
                    room_name = this.jm_list_form.content;
                } else if(this.jm_list_form.select == 'user_name') {
                    user_name = this.jm_list_form.content;
                } else if(this.jm_list_form.select == 'mobile') {
                    mobile = this.jm_list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport/detailCommonExport?bill_type=deposit" +
                    "&start_date=" + this.jm_list_form.start_date +
                    "&end_date=" + this.jm_list_form.end_date +
                    "&shop_id=" + this.jm_list_form.shop_id +
                    "&store_id=" + this.jm_list_form.store_id +
                    "&goods_type=" + this.jm_list_form.goods_type +
                    "&goods_name=" + this.jm_list_form.goods_name +
                    "&deposit_status=" + this.jm_list_form.deposit_status +
                    "&expire_days=" + this.jm_list_form.expire_days +
                    "&relation_id=" + relation_id +
                    "&room_name=" + room_name +
                    "&user_name=" + user_name +
                    "&mobile=" + mobile +
                    "&export_fields=" + JSON.stringify(this.jm_export_ids) +
                    "&export_type=" + this.jm_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>